import { Box, Typography } from '@mui/material';
import SectionGrid from '@shared/components/SectionGrid';

const FormSection = ({
  title,
  children,
  customLayout,
  padding,
  sx = {},
  centerChildren = false,
  spacing = 2,
  mdVal = 6,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 'auto',
        border: '5px solid #E5E5E5',
        borderRadius: 2,
        backgroundColor: '#FFFFFF',
        marginBottom: '8px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
    >
      {title && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
              width: '100%',
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: '#000000',
                fontSize: { xs: '18px', sm: '20px' },
                fontWeight: '600',
                padding: '16px',
                lineHeight: 1,
              }}
            >
              {title}
            </Typography>
          </Box>
          <Box
            sx={{
              height: '5px',
              backgroundColor: '#E5E5E5',
              width: '100%',
            }}
          />
        </>
      )}

      <SectionGrid
        centerChildren={centerChildren}
        customLayout={customLayout}
        spacing={spacing}
        padding={padding}
        mdVal={mdVal}
      >
        {children}
      </SectionGrid>
    </Box>
  );
};

export default FormSection;
